import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "./axios.setup";
import PaymentCheckout from './payements/payment.checkout';
import { fetchPaymentLinkDetailAPI, genrateTokenAPI, getCheckoutAPI } from "./payements/apiSercive";
import Loader from "./Loader/Loader";
import { IPaymentDetail, usePaymnetContext } from ".";
import { getQueryStringValue, PREVIEW_MODE } from "./payements/common";
import InformationCard from "./payements/Information.card/InformationCard";
import i18next from "i18next";
import withClearCache from "./ClearCache";
import packageJson from "../package.json";
import './App.scss';

function App() {
  const { t } = useTranslation();
  const { state, update } = usePaymnetContext();
  const flowDecision = () => {
    let tab: any = document.getElementById("favicon");
    const id = getQueryStringValue("id");
    if (id === PREVIEW_MODE) {
      setupPaymentLinkPreviewFlow();
    } else if (id) {
      document.title = "AzamPay’s Lipia Kwa Uhakika"
      tab.href = "https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-icons/favicon+%281%29.ico"
      setupPaymentLinkFlow();
    } else {
      setupCheckoutFlow();
      document.title = "Checkout"
      tab.href = "https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/favicon.ico"
    }
  }

  const setupPaymentLinkPreviewFlow = () => {
    const paymentDetail: IPaymentDetail = {
      id: getQueryStringValue("id") || "",
      amount: getQueryStringValue("amount") || "",
      vendorName: getQueryStringValue("vendorName") || "",
      currency: getQueryStringValue("currency") || "",
      vendorId: getQueryStringValue("vendorId") || "",
      language: getQueryStringValue("language") || "",
      cart: JSON.parse(getQueryStringValue("cart") || '{ "items": [{ "name": "" }] }')
    }

    i18next.changeLanguage(paymentDetail.language || "en");
    update({
      ...state,
      mode: PREVIEW_MODE,
      success: true,
      loading: false,
      paymentDetail
    });
  }

  const getPaymentDetails = (id: string) => {
    const language = getQueryStringValue("language") || "en";
    fetchPaymentLinkDetailAPI(id, language)
      .then((data: any) => {
        const paymentDetail: IPaymentDetail = {
          id: data.id,
          amount: data.amount,
          vendorName: data.title,
          currency: data.currency,
          appName: data.vendorName,
          cart: data.cart,
          vendorId: data.vendorId,
          externalId: data.externalId,
        };

        update({ ...state, paymentDetail, success: true, loading: false });
      })
      .catch((error: any) => {
        update({
          ...state,
          success: false,
          systemMessage: {
            ...state.systemMessage,
            show: true,
            title: error?.code,
            message: error.message,
          },
        });
      })
      .finally(() => {
        i18next.changeLanguage(language);
      });
  };


  const setupPaymentLinkFlow = () => {
    axios.defaults.headers.common['X-Payment-Link-Api-Key'] = process.env.REACT_APP_X_API_KEY || "";
    const paymentLinkId = getQueryStringValue("id");
    if (paymentLinkId && paymentLinkId !== PREVIEW_MODE) {
      getPaymentDetails(paymentLinkId)
    }
  }

  const genrateToken = (modal: any) => genrateTokenAPI(modal).then((data) => {
    if (data.success) {
      update({ ...state, paymentDetail: modal, success: true, loading: false });
    } else {
      update({ ...state, paymentDetail: modal, loading: false });
    }
  }).catch((error: any) => {
    if (error.StatusCode === 401) {
      return update({
        ...state,
        success: false,
        systemMessage: {
          ...state.systemMessage,
          show: true,
          title: t("genralErrorTitle"),
          message: error.Message,
        }
      });
    }
    update({
      ...state,
      success: false,
      systemMessage: {
        ...state.systemMessage,
        show: true,
        title: t("genralErrorTitle"),
        message: t("genralErrorMsg"),
      }
    });
  })

  const validateModal = (modal: any) => {
    const errors = {
      appName: {
        title: t("inValidAppTitle"),
        message: t("inValidAppMsg")
      },
      clientId: {
        title: t("inValidCliendIdTitle"),
        message: t("inValidCliendIdMsg")
      },
      // vendorName: {
      //   title: t("inValidVendorTitle"),
      //   message: t("inValidVendorMsg")
      // },
      amount: {
        title: t("inValidAmountTitle"),
        message: t("inValidAmountMsg")
      },
      cart: {
        title: t("inValidCartTitle"),
        message: t("inValidCartMsg")
      },
      externalId: {
        title: t("inValidExternalIdTitle"),
        message: t("inValidExternalIddMsg")
      },
      redirectFailURL: {
        title: t("inValidRedirectFailURLTitle"),
        message: t("inValidRedirectFailURLMsg")
      },
      redirectSuccessURL: {
        title: t("inValidRedirectSuccessURLTitle"),
        message: t("inValidRedirectSuccessURLddMsg")
      }
    }

    const errorType = Object.keys(modal).find((item) => modal[item] === "")
    if (errorType) {
      update({
        ...state,
        success: false,
        systemMessage: {
          ...state.systemMessage,
          show: true,
          ...(errors as any)[errorType]
        }
      });
      return false;
    }
    return true;
  }

  const setupCheckoutFlow = async () => {
    const search = window.location.search;
    if (search) {
      const searchValue = search.substring(5);
      getCheckoutAPI("?key=" + encodeURIComponent(searchValue)).then(((modal: any) => {
        i18next.changeLanguage(modal.language || "en");
        if (validateModal(modal)) {
          i18next.changeLanguage(modal.language);
          genrateToken(modal);
        }
      })).catch(((error: any) => {
        update({
          ...state,
          success: false,
          systemMessage: {
            ...state.systemMessage,
            show: true,
            title: error?.code,
            message: error.message
          }
        });
      }));
    }
  }

  useEffect(() => {
    console.log(`Build date (DD/MM/YYYY): ${new Date(packageJson.buildDate).toLocaleString()}`)
    flowDecision();
  }, [])

  if (state.loading) return <div className="spinner-wrapper"><Loader /></div>

  if (!state.success) return <InformationCard
    title={t("uhoh")}
    desc={state.systemMessage.message || t("failDescMsg")}
    redirectText={t("goBack")}
    redirectURL={state.paymentDetail?.redirectFailURL}
  />

  return (
    <div className={`app ${state.mode === PREVIEW_MODE ? "app-preview" : ""}`}>
      <PaymentCheckout />
    </div>
  );
}
export default withClearCache(App);
